// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalizationToggle_container__2dbLf","hide":"PersonalizationToggle_hide__L5cMl"};